import { yup } from "@";

const reqWhen = (provider) =>
  yup.string().when("provider", {
    is: provider,
    then: (s) => s.required("هذا الحقل مطلوب"),
    otherwise: (s) => s.nullable().notRequired(),
  });

export const schema = yup
  .object({
    provider: yup.string().oneOf(["oursms"]).required(),

    // OurSMS
    oursmsUsername: reqWhen("oursms"),
    oursmsPassword: reqWhen("oursms"),
    oursmsSenderName: reqWhen("oursms"),
  })
  .required();

export const defaultValues = {
  provider: "oursms",
  oursmsUsername: "",
  oursmsPassword: "",
  oursmsSenderName: "",
};
